import moment from 'moment'

const ISO_DATE_FORMAT = 'YYYY-MM-DD'

export const PRESET_RANGES = {
  'Today': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  'Yesterday': [moment().startOf('day').subtract(1, 'days').toDate(), moment().endOf('day').subtract(1, 'days').toDate()],
  'Last Week': [moment().startOf('isoWeek').subtract(7, 'days').toDate(), moment().endOf('isoWeek').subtract(7, 'days').toDate()],
  'Last 7 Days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
  'Last 30 Days': [moment().subtract(29, 'days').toDate(), moment().toDate()],
  'Last 90 Days': [moment().subtract(89, 'days').toDate(), moment().toDate()],
  'Last 12 Months': [moment().subtract(13, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')],
  'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
  'Last Month': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()],
  'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
  'Last Quarter': [moment().startOf('quarter').subtract(3, 'months'), moment().endOf('quarter').subtract(3, 'months')],
  'This Year': [moment().startOf('year'), moment().endOf('year')],
  'Last Year': [moment().startOf('year').subtract(1, 'year'), moment().endOf('year').subtract(1, 'year')],
  'Year To Date': [moment().startOf('year'), moment()]
}

/**
 * Make Date object
 *
 * @param {string|Date} date - Date
 *
 * @return {Date} - date
 */
export const makeDate = date => date ? moment(date).toDate() : null

/**
 * Format date
 *
 * @param {string|Date} date - Date to format
 * @param {string} format - Format
 *
 * @return {string} - Formatted date
 */
export const formatDate = (date, format) => date ? moment(date).format(format) : ''

/**
 * Format date in ISO format
 *
 * @param {string|Dat} date - Date to format
 *
 * @return {string} - Formatted date
 */
export const formatISODate = date => formatDate(date, ISO_DATE_FORMAT)

/**
 * Compare 2 dates
 *
 * @param {string|Date} date1 - Date1
 * @param {string|Date} date2 - Date2
 * @param {string} unit - Comparison unit, For example, 'day'
 *
 * @return {boolean} - TRUE if 2 dates are the same
 */
export const isSame = (date1, date2, unit) => moment(date1).isSame(date2, unit)


/**
 *
 * @param date
 * @returns {string}
 */
export const diffForHumans = (date) => moment(date).fromNow()

/**
 *
 * @param {string|Date} date
 * @returns {string}
 */
export const yearsAgo = (date) => moment().diff(date, 'years')